module.exports = __webpack_public_path__ + "static/img/finance-type-saving.7c7178f6.svg";